import { ValidationError } from "sequelize"
import {
    MtAccount,
    MtAccountCreate,
    MtAccountSave,
    MtAccountChangeStatus,
} from "server/models"
import { ACTIVE, INACTIVE } from "const"
import { ActiveInactive, OrderType } from "client/utils"
import { GET, POST, sort, search, validate } from "client/store/utils"
import {
    AccountPackageList,
    LangType,
    PackageAlmostExpireTime,
} from "client/store"
import {
    AccountList,
    AccountFilters,
    AccountValidation,
} from "./types"


export const LoadAllAccounts = () => (
    GET("/mtAccount/all")
    .then((accounts: MtAccount[]) => {
        const accountList: AccountList = {}
        accounts.forEach((account) => {
            accountList[account.id] = account
        })
        return accountList
    })
)

export const LoadAccountById = (accountId: number) => (
    GET(`/mtAccount/id/${accountId}`)
    .then((account: MtAccount) => account)
)

export const SaveAccount = (
    id: number,
    account: MtAccountCreate,
    lang: LangType,
) => {
    const data: MtAccountSave = {
        id,
        account,
    }
    return POST(
        "/mtAccount/save",
        JSON.stringify(data),
    ).then((res) => {
        const newAccount = res as MtAccount
        const error = res as ValidationError

        return {
            newAccountId: newAccount.id || null,
            validation: <AccountValidation>validate(error, lang),
        }
    })
}

export const ChangeAccountStatus = (account: MtAccount) => {
    const status: ActiveInactive = account.status === ACTIVE ? INACTIVE : ACTIVE
    const data: MtAccountChangeStatus = {
        id: account.id,
        status,
    }
    return POST(
        "/mtAccount/changeStatus",
        JSON.stringify(data),
    ).then((updatedRows: [number]) => (
        updatedRows && updatedRows.length && updatedRows[0] === 1
            ? status
            : account.status
    ))
}

export const SortAccounts = (
    accounts: MtAccount[],
    sortColumn: keyof MtAccount,
    sortOrder: OrderType,
    filters: AccountFilters,
    accountPackageList?: AccountPackageList,
): number[] => {
    const now = new Date().getTime()

    const packageAlmostExpireTime = PackageAlmostExpireTime()

    const accountsFiltered = accounts.filter((account) => {
        let showRow = true

        if (
            filters.packageExpired
            || filters.packageAlmostExpired
        ) {
            if (
                accountPackageList
                && accountPackageList[account.id]
                && accountPackageList[account.id].length
            ) {
                const accountPackages = accountPackageList[account.id]
                const packageState = accountPackages[0]
                const packageExpireTime = new Date(packageState.dateEnd).getTime()

                if (filters.packageExpired) {
                    const expired = packageExpireTime <= now
                    showRow = expired
                }
                if (filters.packageAlmostExpired) {
                    const almostExpired = packageExpireTime > now && packageExpireTime - now <= packageAlmostExpireTime
                    showRow = almostExpired
                }
            } else showRow = false
        }

        if (filters.status && account.status !== filters.status) showRow = false
        else if (filters.search) showRow = search(filters.search, account)
        return showRow
    })
    accountsFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const accountIds: number[] = []
    accountsFiltered.forEach((account) => accountIds.push(account.id))

    return accountIds
}
